import { Popover, Stack, Text, UnstyledButton } from '@mantine/core';
import { View } from 'react-big-calendar';
import { IconChevronDown } from '@tabler/icons-react';
import { useState } from 'react';
import classes from './SchedulingCalendarToolbar.module.css';

export type CalendarViewInputProps = {
  view: View;
  onSetView: (view: View) => void;
};

export default function CalendarViewInput({ view, onSetView }: CalendarViewInputProps) {
  const [currentView, setCurrentView] = useState<View>(view);

  const handleChangeView = (view: View) => () => {
    onSetView(view);
    setCurrentView(view);
  };

  return (
    <Popover>
      <Popover.Target>
        <UnstyledButton className={`${classes.actionButton} ${classes.actionGroup}`} pt={0} pr={8}>
          <Text fw={600} tt="capitalize">
            {currentView}
          </Text>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderLeft: '1px solid #246A7A',
              height: '100%',
              marginLeft: 10,
              paddingLeft: 6,
            }}
          >
            <IconChevronDown size={16} />
          </div>
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown style={{ borderRadius: '16px', width: '100px', color: '#212529' }}>
        <Stack>
          <UnstyledButton onClick={handleChangeView('month')}>
            <Text>Month</Text>
          </UnstyledButton>
          <UnstyledButton onClick={handleChangeView('week')}>
            <Text>Week</Text>
          </UnstyledButton>
          <UnstyledButton onClick={handleChangeView('day')}>
            <Text>Day</Text>
          </UnstyledButton>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
